<template>
  <div id="freezelevel">
    <div class="header flex-between">
      <div class="header-text">
        <h1>冻结卡级别-会员消费等级冻结</h1>
      </div>

      <div class="header-button">
        <el-button
          v-if="jurisdiction.search"
          icon="iconfont icon-sousuo1"
          @click="search"
          >查询</el-button
        >
        <el-button
          v-if="jurisdiction.create"
          icon="iconfont icon-chuangjian1"
          @click="createFormVisible = true"
          >创建</el-button
        >
        <el-button
          v-if="jurisdiction.void"
          icon="el-icon-document-delete"
          @click="Zuofeitc"
          >作废</el-button
        >
        <el-button
          v-if="jurisdiction.Import"
          icon="iconfont icon-daoru1"
          @click="MemberFreezeImport = true"
          >从会员冻结导入</el-button
        >
      </div>
    </div>
    <div class="header-card">
      <el-card shadow="never">
        <div class="searchform">
          <el-form :model="queryInfo" size="small">
            <el-row>
              <el-col :span="8">
                <el-form-item label="会员卡号\会员姓名\手机号">
                  <el-input
                    v-model="queryInfo.search"
                    style="width: 55%"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="所属区域">
                  <el-select
                    v-model="queryInfo.regionID"
                    style="width: 55%"
                    @change="changeSelectCur"
                  >
                    <el-option
                      v-for="item in regionList"
                      :key="item.id"
                      :label="item.lable"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="所属门店">
                  <el-select v-model="queryInfo.shopID" style="width: 55%">
                    <el-option
                      v-for="item in shopList"
                      :key="item.id"
                      :label="item.lable"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-form-item label="当前冻结名单">
                  <el-checkbox-group v-model="queryInfo.state">
                    <el-checkbox :true-label="1" :false-label="0"></el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-card>
    </div>
    <!-- 创建弹窗 -->
    <div class="create">
      <el-dialog
        width="30%"
        title="冻结卡级别—创建"
        :visible.sync="createFormVisible"
        :close-on-click-modal="false"
        @close="addDialogClosed"
      >
        <div>
          <!-- 创建弹窗内容主体区域 -->
          <el-form
            size="mini"
            label-width="110px"
            :rules="createFormRules"
            :model="createForm"
            ref="createFormRef"
          >
            <el-row>
              <el-col :span="24">
                <el-form-item label="会员姓名" prop="custName">
                  <el-input
                    style="width: 55%"
                    v-model="createForm.custName"
                    :disabled="true"
                  ></el-input>
                  <el-button
                    @click="xuanzehuiyuan"
                    style="
                      width: 75px;
                      background-color: #f7f5f4;
                      color: #4d4d4d;
                      margin-left: 10px;
                    "
                    size="small"
                    >选择会员</el-button
                  >
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="会员卡号" prop="cardNo">
                  <div class="flex-between">
                    <el-input
                      style="width: 75%"
                      v-model="createForm.cardNo"
                      :disabled="true"
                    >
                    </el-input>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="会员等级" prop="levelName">
                  <el-input
                    style="width: 75%"
                    v-model="createForm.levelName"
                    :disabled="true"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="所属区域" prop="regionName">
                  <div class="flex-between">
                    <el-input
                      style="width: 75%"
                      v-model="createForm.regionName"
                      :disabled="true"
                    >
                    </el-input>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="所属门店" prop="shopName">
                  <el-input
                    style="width: 75%"
                    v-model="createForm.shopName"
                    :disabled="true"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="移动电话" prop="mobile">
                  <el-input
                    style="width: 75%"
                    v-model="createForm.mobile"
                    :disabled="true"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="备注" prop="remark">
                  <el-input
                    :rows="3"
                    style="width: 75%"
                    type="textarea"
                    v-model="createForm.remark"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12"> </el-col>
            </el-row>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="addUser('createFormRef')">保 存</el-button>
          <el-button @click="createFormVisible = false">取 消</el-button>
        </div>
      </el-dialog>
      <!-- 选择会员弹窗 -->
      <div class="sales">
        <el-dialog
          width="46%"
          title="冻结卡-创建-选择会员"
          :visible.sync="innerVisible"
          :close-on-click-modal="false"
        >
          <div style="width: 600px; margin-top: 10px">
            <el-form size="mini" label-width="180px" ref="">
              <el-form-item label="会员卡号\会员姓名\手机号">
                <div class="flex-between">
                  <el-input v-model="searchFormhy.search"> </el-input>
                  <el-button
                    style="
                      width: 80px;
                      margin-left: 10px;
                      background-color: #f1f1f1;
                      color: #b6b388;
                    "
                    size="small"
                    icon="el-icon-search"
                    @click="searchhy"
                    >查询</el-button
                  >
                </div>
              </el-form-item>
            </el-form>
          </div>
          <div style="margin-top: 10px">
            <el-table
              size="small"
              class="table-style"
              height="280px"
              border
              :row-class-name="tableRowClassName"
              :header-cell-style="{
                background: '#FCFBF2',
                color: '#6C6839',
                'text-align': 'center',
              }"
              :cell-style="{ 'text-align': 'center' }"
              ref="multipleTable1"
              :data="tableData2"
              tooltip-effect="dark"
              v-el-table-infinite-scroll="load"
              v-loading="loading"
              infinite-scroll-disabled="onLoading"
            >
              <el-table-column label width="30">
                <template slot-scope="scope">
                  <el-radio
                    :label="scope.$index"
                    v-model="radioxz"
                    @change.native="getCurrentRow(scope.row)"
                    >&nbsp;</el-radio
                  >
                </template>
              </el-table-column>
              <el-table-column prop="custName" label="会员姓名">
              </el-table-column>
              <el-table-column prop="cardNo" width="115px" label="会员卡号">
              </el-table-column>
              <el-table-column prop="levelName" label="会员等级">
              </el-table-column>
              <el-table-column prop="regionName" label="所属区域">
              </el-table-column>
              <el-table-column prop="shopName" label="所属门店">
              </el-table-column>
              <el-table-column prop="mobile" label="移动电话">
              </el-table-column>
              <el-table-column prop="state" label="状态">
                <template slot-scope="scope">
                  {{ scope.row.state === 0 ? "有效" : "无效" }}
                </template>
              </el-table-column>
            </el-table>
            <el-alert
              v-if="isMore"
              title="没有更多数据了!"
              type="warning"
              center
              :closable="false"
            >
            </el-alert>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="Selectedvaluetransfer">确 定</el-button>
            <el-button @click="innerVisible = false">取 消</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
    <!-- 会员冻结导入弹窗 -->
    <div class="import">
      <el-dialog
        title="会员消费等级—会员消费等级冻结-导入"
        :visible.sync="MemberFreezeImport"
        :close-on-click-modal="false"
        width="40%"
        @close="uploadClose"
      >
        <el-form
          size="mini"
          label-width="240px"
          ref="newUploadForm"
          :rules="newUploadFormRules"
          enctype="multipart/form-data"
          :model="uploadForm"
        >
          <el-form-item label="选择待导入会员消费等级冻结文件" prop="filename">
            <div class="flex-start">
              <el-input
                style="width: 180%"
                v-model="uploadForm.filename"
                :readonly="true"
                placeholder="请选择文件"
              >
              </el-input>
              <el-upload
                ref="mYupload"
                action="#"
                :show-file-list="false"
                :on-change="handleExcel"
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                :auto-upload="false"
              >
                <el-button style="margin-left: 10px">选择文件</el-button>
              </el-upload>
            </div>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button icon="el-icon-download" @click="Xiazaimukuai"
            >下载模板</el-button
          >
          <el-button icon="el-icon-check" @click="submitUpload('newUploadForm')"
            >执行</el-button
          >
        </span>
      </el-dialog>
      <!-- 执行弹窗 -->
      <div class="">
        <el-dialog
          title="会员消费等级—会员消费等级冻结-导入"
          :visible.sync="implement"
          width="45%"
          :close-on-click-modal="false"
        >
          <el-table
            class="table-style"
            size="small"
            height="380px"
            border
            :row-class-name="tableRowClassName"
            :header-cell-style="{
              background: '#FCFBF2',
              'text-align': 'center',
              color: '#6C6839',
            }"
            :cell-style="{ 'text-align': 'center' }"
            ref="uploadqdTable"
            :data="dongjie"
            tooltip-effect="dark"
            style="width: 100%; margin-top: 10px"
            @selection-change="uploadxuandin"
          >
            <el-table-column type="selection" min-width="40%">
            </el-table-column>
            <el-table-column prop="custName" label="会员姓名">
            </el-table-column>
            <el-table-column prop="cardNo" label="会员卡号" min-width="118%">
            </el-table-column>
            <el-table-column prop="levelName" label="会员等级" min-width="100%">
            </el-table-column>
            <el-table-column prop="regionName" label="所属区域">
            </el-table-column>
            <el-table-column
              prop="shopName"
              label="所属门店"
              min-width="100%"
            ></el-table-column>
            <el-table-column
              prop="mobile"
              label="移动电话"
              min-width="100%"
            ></el-table-column>
            <el-table-column
              prop="Startfreeze"
              label="开始冻结日期"
              min-width="98%"
            >
            </el-table-column>
            <el-table-column
              prop="Endfreeze"
              label="结束冻结日期"
              min-width="98%"
            >
            </el-table-column>
            <el-table-column prop="createUserName" label="创建人">
            </el-table-column>
            <el-table-column prop="createDate" label="创建日期" min-width="98%">
              <template slot-scope="scope">
                {{ scope.row.createDate | dateFormat }}
              </template>
            </el-table-column>
          </el-table>
          <span slot="footer" class="dialog-footer">
            <el-button icon="" @click="implement = false">返回</el-button>
            <el-button
              icon="el-icon-user-solid"
              @click="toggleSelection(dongjie)"
              >全选</el-button
            >
            <el-button icon="el-icon-user" @click="toggleSelection()"
              >取消全选</el-button
            >
            <el-button icon="el-icon-folder-checked" @click="Savefreeze"
              >保存</el-button
            >
          </span>
        </el-dialog>
      </div>
      <!-- 导入冻结保存确认对话框 -->
      <div class="confirm">
        <el-dialog
          width="20%"
          title="导入冻结保存确认对话框"
          :visible.sync="Saveconfirmation"
          :close-on-click-modal="false"
        >
          <div style="height: 50px; font-size: 14px; font-weight: 700">
            <p>
              <i
                class="iconfont icon-jingshi"
                style="font-size: 28px; color: #f39b21"
              ></i>
              真的要保存会员消费等级冻结记录吗?
            </p>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="Confirmfreezing">确 定</el-button>
            <el-button @click="Saveconfirmation = false">取 消</el-button>
          </div>
        </el-dialog>
      </div>
      <!-- 作废确认对话框 -->
      <div class="zuofei">
        <el-dialog
          width="20%"
          title="作废确认对话框"
          :visible.sync="Voidconfirmation"
          :close-on-click-modal="false"
        >
          <div style="height: 50px; font-size: 14px; font-weight: 700">
            <p>
              <i
                class="iconfont icon-jingshi"
                style="font-size: 28px; color: #f39b21"
              ></i>
              真的要作废冻结记录吗?
            </p>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="Tovoid">确 定</el-button>
            <el-button @click="Voidconfirmation = false">取 消</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
    <!-- 首页列表 -->
    <el-card shadow="never" class="centercard">
      <el-table
        class="table-style"
        height="500px"
        border
        size="small"
        :row-class-name="tableRowClassName"
        :header-cell-style="{
          background: '#FCFBF2',
          'text-align': 'center',
          color: '#6C6839',
          fontSize: '14px',
        }"
        :cell-style="{ 'text-align': 'center' }"
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        v-el-table-infinite-scroll="loadd"
        v-loading="loadingg"
        infinite-scroll-disabled="onLoadingg"
      >
        <el-table-column width="40">
          <template slot-scope="scope">
            <el-radio
              :label="scope.$index"
              v-model="radio"
              @change="handleRadioChange(scope.row)"
              >&nbsp;</el-radio
            >
          </template>
        </el-table-column>
        <el-table-column prop="custName" label="会员姓名"> </el-table-column>
        <el-table-column prop="cardNo" label="会员卡号"> </el-table-column>
        <el-table-column prop="levelName" label="会员等级"> </el-table-column>
        <el-table-column prop="regionName" label="所属区域"> </el-table-column>
        <el-table-column prop="shopName" label="所属门店"> </el-table-column>
        <el-table-column prop="mobile" label="移动电话"> </el-table-column>
        <el-table-column prop="state" label="状态">
          <template slot-scope="scope">
            {{ scope.row.state === 0 ? "有效" : "无效" }}
          </template>
        </el-table-column>
        <el-table-column prop="createUserName" label="创建人">
        </el-table-column>
        <el-table-column prop="createTime" label="创建日期">
          <template slot-scope="scope">
            {{ scope.row.createTime | dateFormat }}
          </template>
        </el-table-column>
      </el-table>
      <el-alert
        v-if="isMoree"
        title="没有更多啦!"
        type="warning"
        center
        show-icon
        :closable="false"
      >
      </el-alert>
    </el-card>
  </div>
</template>

<script>
// import { getcpyNo } from "@/utils/auth";
import { freezePageApi } from "@/api/user";
import { freezeInsertApi } from "@/api/user";
import {
  freezeThawApi,
  importFreezeExcelApi,
  insertBatchFreezeApi,
} from "@/api/user";
import { queryRegionApi, selectCustListApi } from "@/api/shop";
export default {
  name: "centre",

  data() {
    return {
      huiyuan: {
        fileUrl: "",
        cardNoList: [],
      },
      checkbox: [],
      formRules: {
        // 表单 校验
        password: {
          required: true,
          trigger: "blur",
        },
      },
      radio: "",
      // 选择会员radio
      radioxz: "",
      // isMore: true,
      loading: false,
      loadingg: false,
      // 导入冻结保存确认对话框
      Saveconfirmation: false,
      // 作废确认对话框
      Voidconfirmation: false,
      // 会员冻结导入弹窗
      MemberFreezeImport: false,
      // 执行弹窗
      implement: false,
      createFormVisible: false,
      // 创建内部弹窗
      innerVisible: false,
      // 创建表单
      createForm: {
        custName: "",
        cardNo: "",
        levelName: "",
        regionName: "",
        shopName: "",
        mobile: "",
        remark: "",
        custID: "",
      },
      // 搜索
      searchForm: {
        search: "",
        pageNo: 1,
        pageSize: 50,
        regionID: "",
        shopID: "",
        state: "",
      },
      statee: "",
      // 选择会员搜索
      searchFormhy: {
        search: "",
        pageNo: 1,
        pageSize: 50,
      },
      regionList: [],
      shopList: [{ id: "", lable: "全部门店" }],
      options1: [],
      options2: [],
      form: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: "",
      },
      // 选择会员列表
      queryhy: {
        search: "",
        pageNo: 1,
        pageSize: 50,
        pages: 0,
      },
      radioValueList: [], //选中的数据
      Tovoidlist: {
        custID: "",
        lvlFreezeID: "",
      },
      templatei: [], // 获取选择会员弹窗选中的值
      tableData: [],
      // 中心表格列表
      queryInfo: {
        state: "",
        search: "",
        pageNo: 1,
        pageSize: 50,
        pages: 0,
        regionID: "",
        shopID: "",
      },
      // 内层弹窗数据
      tableData2: [],
      // 会员批量导入
      uploadForm: {
        filename: "", //文件名
      },
      // filename: "", //文件名
      formData: {}, // 文件
      showFileList: false, //文件列表是否显示,默认不显示
      // 会员冻结导入弹窗数据
      dongjie: [
        {
          custName: "",
          cardNo: "",
          levelName: "",
          regionName: "",
          shopName: "",
          mobile: "",
          Startfreeze: "",
          Endfreeze: "",
          createUserName: "",
          createDate: "",
        },
      ],
      // 全选或否
      allselect: false,
      // 创建会员冻结卡的表单验证
      createFormRules: {
        custName: [
          { required: true, message: "请选择会员用户", trigger: "blur" },
        ],
        cardNo: [
          { required: true, message: "请选择会员卡号", trigger: "blur" },
        ],
        levelName: [
          { required: true, message: "请选择会员等级", trigger: "blur" },
        ],
        regionName: [
          { required: true, message: "请选择所属区域", trigger: "blur" },
        ],
        shopName: [
          { required: true, message: "请选择所在门店", trigger: "blur" },
        ],
        mobile: [
          { required: true, message: "请选择移动电话", trigger: "blur" },
        ],
      },
      // 会员消费等级冻结导入
      newUploadFormRules: {
        filename: [{ required: true, message: "请选择文件", trigger: "blur" }],
      },
      jurisdiction: {
        search: false,
        create: false,
        void: false,
        Import: false,
      },
    };
  },
  created() {
    this.freezeInvalidList();
    this.regionSelectList();
    let FreezeLevel = JSON.parse(localStorage.getItem("FreezeLevel"));
    for (let i = 0; i < FreezeLevel.length; i++) {
      if (FreezeLevel[i].menuName == "查询") {
        this.jurisdiction.search = true;
        continue;
      }
      if (FreezeLevel[i].menuName == "创建") {
        this.jurisdiction.create = true;
        continue;
      }
      if (FreezeLevel[i].menuName == "作废") {
        this.jurisdiction.void = true;
        continue;
      }
      if (FreezeLevel[i].menuName == "从会员冻结导入") {
        this.jurisdiction.Import = true;
        continue;
      }
    }
  },
  computed: {
    isMore() {
      //当起始页数等于总页数时停止加载
      return this.queryhy.pageNo >= this.queryhy.pages;
    },
    onLoading() {
      return this.loading || this.isMore;
    },
    isMoree() {
      //当起始页数等于总页数时停止加载
      return this.queryInfo.pageNo >= this.queryInfo.pages;
    },
    onLoadingg() {
      return this.loadingg || this.isMoree;
    },
  },
  methods: {
    // 点击确定创建会员冻结卡
    addUser(createFormRef) {
      this.$refs[createFormRef].validate(async (valid) => {
        if (!valid) return;
        // 可以发送请求创建会员冻结卡
        await freezeInsertApi(this.createForm).then((res) => {
          if (res.message !== "success") {
            this.$message.error("创建会员冻结卡失败");
            return;
          }
          this.$message.success("创建会员冻结卡成功");
          this.radio = "";
          this.Tovoidlist.custID = "";
          // 隐藏创建会员冻结对话框
          this.createFormVisible = false;
          // 重新获取冻结卡列表
          this.freezeInvalidList();
        });
      });
    },
    // 监听创建冻结卡对话框的关闭事件
    addDialogClosed() {
      this.$refs.createFormRef.resetFields();
    },
    // 点击选择会员发送请求
    xuanzehuiyuan() {
      this.queryhy.pageNo == 1;
      this.selectCustListApi();
      this.innerVisible = true;
    },
    // 选择会员
    Selectedvaluetransfer() {
      this.createForm.custName = this.templatei.custName;
      this.createForm.cardNo = this.templatei.cardNo;
      this.createForm.levelName = this.templatei.levelName;
      this.createForm.regionName = this.templatei.regionName;
      this.createForm.shopName = this.templatei.shopName;
      this.createForm.mobile = this.templatei.mobile;
      this.createForm.custID = this.templatei.custID;
      this.innerVisible = false;
    },
    getCurrentRow(row) {
      // 获取选中数据   row表示选中这一行的数据，可以从里面提取所需要的值
      this.templatei = row;
    },
    // 判断如果是单行就变黄色双行是白色
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
    // 点击获取中心表格数据
    handleRadioChange(value) {
      this.radioValueList = value;
      this.Tovoidlist.custID = this.radioValueList.custID;
      this.Tovoidlist.lvlFreezeID = this.radioValueList.lvlFreezeID;
    },
    // 冻结卡列表
    async freezeInvalidList() {
      await freezePageApi(this.queryInfo).then((res) => {
        if (this.queryInfo.pageNo == 1) this.tableData = [];
        this.tableData = this.tableData.concat(res.data.list);
        this.queryInfo.pages = res.data.pages;
        this.loadingg = false;
      });
    },
    loadd() {
      //滑到底部时进行加载
      this.loadingg = true;
      setTimeout(() => {
        this.queryInfo.pageNo += 1;
        this.freezeInvalidList();
      }, 1000);
    },
    // 冻结卡列表搜索
    async search() {
      this.queryInfo.pageNo = 1;
      await freezePageApi(this.queryInfo).then((res) => {
        if (res.message !== "success") {
          this.$message.error("查询会员失败");
          return;
        }
        this.$message.success("查询会员成功");
        this.radio = "";
        this.Tovoidlist.custID = "";
        this.tableData = res.data.list;
        this.queryInfo.pages = res.data.pages;
      });
    },
    // 选择会员窗口查询信息
    async searchhy() {
      await selectCustListApi(this.searchFormhy).then((res) => {
        this.tableData2 = res.data.list;
      });
    },
    // 所属区域
    regionSelectList() {
      queryRegionApi({ regionID: "" }).then((res) => {
        if (res.success) {
          this.regionList.push({
            id: "",
            lable: "全部区域",
          });
          this.regionList.push(...res.data);
        }
      });
    },
    // 所属门店
    changeSelectCur() {
      for (let k in this.regionList) {
        if (this.queryInfo.regionID === this.regionList[k].id) {
          this.queryInfo.shopID = "";
          this.shopList = [];
          this.shopList.push({
            id: "",
            lable: "全部门店",
          });
          this.shopList.push(...this.regionList[k].chlidren);
        }
      }
    },
    // 选择会员列表
    async selectCustListApi() {
      await selectCustListApi(this.queryhy).then((res) => {
        if (this.queryhy.pageNo == 1) this.tableData2 = [];
        this.tableData2 = this.tableData2.concat(res.data.list);
        this.queryhy.pages = res.data.pages;
        this.loading = false;
      });
    },
    load() {
      //滑到底部时进行加载
      this.loading = true;
      setTimeout(() => {
        this.queryhy.pageNo += 1;
        this.selectCustListApi();
      }, 1000);
    },
    // 冻结卡级别 -- 作废弹窗
    Zuofeitc() {
      if (this.Tovoidlist.custID.length == 0) {
        this.$message.error("请选择会员");
        return;
      }
      this.Voidconfirmation = true;
    },
    // 冻结卡级别--作废
    async freezeThawApi() {
      if (this.radioValueList.state !== 1) {
        await freezeThawApi(this.Tovoidlist).then((res) => {
          if (res.message !== "success") {
            this.$message.error("作废会员失败");
            return;
          }
          this.$message.success("作废会员成功");
          this.freezeInvalidList();
          this.radio = "";
          this.Tovoidlist.custID = "";
        });
      } else {
        this.$message.error("记录是无效状态，不可以做作废操作");
      }
    },
    // 作废请求事件
    Tovoid() {
      this.freezeThawApi();
      this.Voidconfirmation = false;
    },
    // 冻结卡导入
    handleExcel(file) {
      this.formData = new FormData(); //声明一个FormDate对象
      this.formData.append("file", file.raw); //把文件信息放入对象中
      this.uploadForm.filename = file.name;
    },
    //调用后台导入的接口
    // 点击执行发送上传请求
    submitUpload(newUploadForm) {
      this.$refs[newUploadForm].validate(async (valid) => {
        if (!valid) return;
        await importFreezeExcelApi(this.formData)
          .then((res) => {
            if (res.message == "success") {
              this.$message.success("导入成功");
              this.defaultisderived = true;
              this.dongjie = res.data.list;
              this.huiyuan.fileUrl = res.data.fileUrl;
              this.$refs.mYupload.clearFiles();
              this.implement = true;
            }
          })
          .catch((err) => {
            console.log(err);
            this.$message({
              type: "error",
              message: "导入失败",
            });
          });
      });
    },
    // 监听导入弹窗关闭事件
    uploadClose() {
      this.$refs.newUploadForm.resetFields();
      this.$refs.mYupload.clearFiles();
    },
    // 下载模块
    Xiazaimukuai() {
      const ele = document.createElement("a");
      ele.style.display = "none";
      // 设置href属性为文件路径，download属性可以设置文件名称
      ele.href =
        process.env.VUE_APP_BASE_API + "/api/templates/消费等级冻结模板.xlsx";
      ele.download = "";
      // 将a标签添加到页面并模拟点击
      document.querySelectorAll("body")[0].appendChild(ele);
      ele.click();
      // 移除a标签
      ele.remove();
    },

    // 冻结卡点击执行弹窗列表 ----
    // 冻结卡弹窗列表单选获取数据
    uploadxuandin(value) {
      this.checkbox = value;
    },
    // 冻结卡弹窗列表全选
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.uploadqdTable.toggleRowSelection(row, !this.allselect);
        });
      } else {
        this.$refs.uploadqdTable.clearSelection();
        this.cardNoList = "";
      }
    },
    // 保存冻结确定弹窗
    Savefreeze() {
      this.Saveconfirmation = true;
    },
    // 确定冻结弹窗
    Confirmfreezing() {
      for (var i = 0; i < this.checkbox.length; i++) {
        this.huiyuan.cardNoList.push(this.checkbox[i].cardNo);
      }
      let data = require("qs").stringify({
        fileUrl: this.huiyuan.fileUrl,
        cardNoList: this.huiyuan.cardNoList.join(","),
      });
      insertBatchFreezeApi(data).then((res) => {
        if (res.message !== "success") {
          this.$message.error("批量冻结失败");
          return;
        }
        this.$message.success("批量冻结成功");
        this.Saveconfirmation = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
#freezelevel {
  height: 100%;
}
.header {
  .header-text {
    height: 30px;
    margin-top: 20px;
    color: #76734f;
  }
}
.searchform {
  margin-top: 10px;
}
.centercard {
  margin-top: 10px;
}
.card-pagination {
  margin-top: 10px;
  text-align: right;
}
// 按钮边框去掉，文字颜色和加粗
/deep/button {
  border-color: #e6e0af;
  border-radius: 7px;
  color: #a19b59;
}

// input框的背景色和取消圆角
/deep/input {
  border-radius: 0;
}
// 去除表头复选框
/deep/.table-style {
  .el-table-column--selection.is-leaf .el-checkbox {
    display: none;
  }
}

::v-deep {
  .el-table .warning-row {
    background: #fcfbf2;
  }

  .el-table .success-row {
    background: #ffffff;
  }
  // 改变分页背景色
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #3c3a2d !important;
    color: #ffffff !important;
  }
  // 改变分页字体颜色
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    color: #d1cda5 !important;
  }
  // 设置表单里字体的颜色
  .el-form-item__label {
    color: #76734f;
  }
  // 创建弹窗样式
  .create {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__body {
      padding: 10px 30px 20px 30px;
    }
    .el-dialog__footer {
      height: 60px;
      background-color: #f2f2f2;
    }

    .el-textarea__inner {
      // 取消拉伸样式
      resize: none;
    }
  }

  // 会员冻结导入弹窗
  .import {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__body {
      padding: 10px 30px 20px 30px;
    }
    .el-dialog__footer {
      height: 60px;
      background-color: #f2f2f2;
    }

    .el-textarea__inner {
      // 取消拉伸样式
      resize: none;
    }
  }
  // 导入冻结保存确认对话框
  .confirm {
    .el-dialog__header,
    .el-message-box__header {
      border-top-left-radius: 9px;
      border-top-right-radius: 9px;
      height: 44px;
      background: #f3f1dd;
      width: 100%;
      text-align: center;
      color: #666;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
      box-sizing: border-box;
    }
    .el-dialog__title,
    .el-message-box__title {
      color: #6c6937;
      font-weight: 700;
      font-size: 16px !important;
    }
    .el-dialog .el-dialog__body {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .coverage-release .el-dialog__body {
      padding: 20px;
    }
    .el-button:hover {
      background-color: #b6b388;
    }
    .el-dialog__body {
      padding: 30px 60px;
    }
    .el-tabs__item {
      border: 1px solid #d9d9d9;
      background-color: #fff;
      color: #6c6937;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }

    .el-tabs__item.is-active {
      color: #6c6937;
      background-color: #f3f1dd;
    }
    .el-form-item__content {
      line-height: 0px;
    }
    .el-textarea__inner {
      // 取消拉伸样式
      resize: none;
    }
  }
  // 作废确认对话框
  .zuofei {
    .el-dialog__header,
    .el-message-box__header {
      border-top-left-radius: 9px;
      border-top-right-radius: 9px;
      height: 44px;
      background: #f3f1dd;
      width: 100%;
      text-align: center;
      color: #666;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
      box-sizing: border-box;
    }
    .el-dialog__title,
    .el-message-box__title {
      color: #6c6937;
      font-weight: 700;
      font-size: 16px !important;
    }
    .el-dialog .el-dialog__body {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .coverage-release .el-dialog__body {
      padding: 20px;
    }
    .el-button:hover {
      background-color: #b6b388;
    }
    .el-dialog__body {
      padding: 30px 60px;
    }
    .el-tabs__item {
      border: 1px solid #d9d9d9;
      background-color: #fff;
      color: #6c6937;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }

    .el-tabs__item.is-active {
      color: #6c6937;
      background-color: #f3f1dd;
    }
    .el-form-item__content {
      line-height: 0px;
    }
    .el-textarea__inner {
      // 取消拉伸样式
      resize: none;
    }
  }
}
</style>
